import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'app/types';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.jitSetupState || initialState;

export const selectJitSetup = createSelector(
  [selectDomain],
  setupState => setupState,
);
